import { configureStore } from '@reduxjs/toolkit'
import authReducer from 'src/store/features/auth/authSlice'
import forgotPasswordReducer from 'src/store/features/forgotPassword/forgotPasswordSlice'
import staticPageContentReducer from 'src/store/features/staticPageContent/staicPageContentSlice'
import commonReducer from 'src/store/features/common/commonSlice'

// rtk
import usersApi from 'src/api/usersApi'
import manageParksApi from 'src/api/manageParksApi'
import aiTrainerApi from 'src/api/aiTrainerApi'
import manageProductsApi from 'src/api/manageProductsApi'
import postsApi from 'src/api/postsApi'
import notificationsApi from 'src/api/notificationsApi'
import membershipApi from 'src/api/membershipApi'
import manageParentGymsApi from 'src/api/parentGymApi'
import manageBranchGymsApi from 'src/api/branchGymApi'

const store = configureStore({
  reducer: {
    auth: authReducer,
    forgotPassword: forgotPasswordReducer,
    staticPageContent: staticPageContentReducer,
    common: commonReducer,

    [usersApi.reducerPath]: usersApi.reducer,
    [postsApi.reducerPath]: postsApi.reducer,
    [manageParksApi.reducerPath]: manageParksApi.reducer,
    [aiTrainerApi.reducerPath]: aiTrainerApi.reducer,
    [manageProductsApi.reducerPath]: manageProductsApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [membershipApi.reducerPath]: membershipApi.reducer,
    [manageParentGymsApi.reducerPath]: manageParentGymsApi.reducer,
    [manageBranchGymsApi.reducerPath]: manageBranchGymsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(usersApi.middleware)
      .concat(manageParksApi.middleware)
      .concat(aiTrainerApi.middleware)
      .concat(manageProductsApi.middleware)
      .concat(postsApi.middleware)
      .concat(notificationsApi.middleware)
      .concat(membershipApi.middleware)
      .concat(manageParentGymsApi.middleware)
      .concat(manageBranchGymsApi.middleware),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store